import { styled, Grid } from '@mui/material';
import React from 'react';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, WIDGET_SPACE } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';

var _a;
var TiledImagesContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var _c = _a["vertical-padding"], horizontalPadding = _c === void 0 ? WIDGET_SPACE : _c, theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: horizontalPadding,
            paddingBottom: horizontalPadding,
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var CaptionContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        textAlign: 'center',
        fontSize: '16px',
        lineHeight: '32px',
        color: theme.palette.primary.main,
    });
});
var ImagesContainer = styled(Grid)((_a = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        width: '100%',
        flexDirection: 'row',
        gap: 20,
        position: 'relative'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        flexDirection: 'column',
        alignItems: 'center',
    },
    _a));
var Tile = function (_a) {
    var children = _a.children;
    return React.createElement("div", { style: { flex: 1, maxWidth: '100%' } }, children);
};
var TiledImagesWidget = function (_a) {
    var caption = _a.caption, spotlight1 = _a.spotlight1, spotlight2 = _a.spotlight2, spotlight3 = _a.spotlight3, verticalPadding = _a.verticalPadding;
    return (React.createElement(TiledImagesContainer, { "vertical-padding": verticalPadding },
        React.createElement("div", { style: { alignItems: 'center' } },
            React.createElement(ImagesContainer, { container: true, wrap: "nowrap" },
                React.createElement(Tile, null, React.createElement(spotlight1.ImgWidget, null)),
                React.createElement(Tile, null, React.createElement(spotlight2.ImgWidget, null)),
                React.createElement(Tile, null, React.createElement(spotlight3.ImgWidget, null)))),
        React.createElement(CaptionContainer, null, caption)));
};

export { TiledImagesWidget };
//# sourceMappingURL=TiledImagesWidget.js.map
